import Image from "next/image";
import {mediaUrl} from "@/lib/config/app";
import Link from "next/link";
import PureHtml from "@/components/custom/PureHtml";

export default function FeaturedCollections({fcols}) {
    const fstyle = fcols?.style || 'style1';
    const fcats = fcols?.scats || [];
    return (
        <section className={`featured-collections py-3 lg:py-4 ${fstyle}`}>
            <div className={'max-w-7xl mx-auto px-2'}>
                <h2 className={'text-xl lg:text-2xl'}>{fcols?.heading}</h2>
                <PureHtml html={fcols?.subtext}/>
                {fcats?.length > 0 && (
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-3">
                        {fcats.map((fcat, index) => {
                            const key = fcat?.id || index;
                            const stitle = fcat?.cat_name || "Collection";
                            const imageAlt = fcat?.image_alt || fcat?.cat_name || "Collection";
                            const linkurl = `/collections/${fcat?.cat_slug}` || "/collections";
                            const aimage = `${mediaUrl}${fcat?.image_url || 'noimage.png'}`;
                            const content = renderCard(fstyle, stitle, aimage,imageAlt);
                            if (fstyle === 'style3') {
                                return <div key={key} title={stitle} className={'pics'}>{content}</div>;
                            }
                            return (
                                <Link key={key} href={linkurl} className={'fcat'} title={stitle}>
                                    {content}
                                </Link>
                            )
                        })}
                    </div>
                )}
            </div>
        </section>
    )
}

function renderCard(fstyle, stitle, aimage,imageAlt) {
    switch (fstyle) {
        case 'style1':
            return (
                <div className={'relative shadow border border-secondary/20 rounded aspect-4/5'}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} width={320} height={320} quality={70} sizes="(max-width: 768px) 50vw, 20vw"
                           className={`rounded w-full h-auto`} />
                    <h3 className={'fcatname py-2 ps-4 pe-8 w-fit border-l-0 drop-shadow-gray-500 drop-shadow-xs absolute left-0 top-9 font-heading text-base text-slate-700 leading-tight before:bg-white before:top-0 before:left-0 before:absolute before:h-full before:inset-0 before:w-full before:-z-1 before:[clip-path:polygon(0_0,100%_0,calc(100%-20px)_100%,0_100%)]'}>
                        {stitle}
                    </h3>
                </div>
            );

        case 'style1b':
            return (
                <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} sizes="(max-width: 768px) 50vw, 20vw"
                           className={'rounded w-full h-auto'} />
                    <div className={'absolute top-2 lg:top-4 left-2 lg:left-4'}>
                        <h3 className={'text-base lg:text-xl font-heading mb-1 lg:mb-2 text-white drop-shadow-black drop-shadow-xs'}>{stitle}</h3>
                        <div className={'text-xs lg:text-sm font-heading inline-block py-0.5 px-3 rounded bg-secondary text-white shadow'}>Shop Now</div>
                    </div>
                </div>
            );

        case 'style2':
            return (
                <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} sizes="(max-width: 768px) 50vw, 20vw"
                           className={'rounded w-full h-auto'} quality={50} />
                    <h3 className={'hidden'}>{stitle}</h3>
                </div>
            );

        case 'style4':
            return (
                <div>
                    <div className={'relative shadow border border-secondary/20 rounded'}>
                        <Image src={aimage} width={320} height={320} alt={`Shop ${imageAlt}`} quality={70} sizes="(max-width: 768px) 50vw, 20vw"
                               className={`w-full h-auto rounded`} />
                    </div>
                    <div className={'relative bg-white/90 px-2 mt-2'}>
                        <h3 className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>
                            {stitle}
                        </h3>
                    </div>
                </div>
            );

        case 'style5':
            return (
                <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} quality={70} width={350} height={350} sizes="(max-width: 768px) 50vw, 20vw"
                           className={`w-full h-auto rounded`} />
                    <h3 className={'absolute top-2 lg:top-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10'}>
                        <div className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>{stitle}</div>
                    </h3>
                </div>
            );

        case 'style5b':
            return (
                <div className={'relative shadow border border-secondary/20 rounded'}>
                    <Image src={aimage} alt={`Shop ${imageAlt}`} quality={70} width={350} height={350} sizes="(max-width: 768px) 50vw, 20vw"
                           className={`w-full h-auto rounded`} />
                    <h3 className={'absolute bottom-2 lg:bottom-4 left-2 lg:left-1/20 bg-white/90 px-2 rounded shadow-lg w-9/10'}>
                        <div className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>{stitle}</div>
                    </h3>
                </div>
            );

        case 'style6':
            return (
                <div>
                    <div className={'relative shadow border border-secondary/20 rounded-full aspect-square'}>
                        <Image src={aimage} alt={`Shop ${imageAlt}`} quality={70} fill sizes="(max-width: 768px) 50vw, 20vw"
                               className={`object-cover rounded-full`} />
                    </div>
                    <div className={'relative bg-white/90 px-2 mt-2'}>
                        <h3 className={'text-sm lg:text-base font-heading py-1 line-clamp-1 text-center capitalize'}>
                            {stitle}
                        </h3>
                    </div>
                </div>
            );

        default:
            return null;
    }
}